<div>
	<gob-header></gob-header>
	<div class="block form-admin">
		<gob-step-order [ind]="3"></gob-step-order>

		<div class="valid-container">
			<div>
				<div class="icon">
					<i class="fa-light fa-circle-exclamation"></i>
				</div>
				<div>
					Aïe... Un problème est survenu lors de la validation de votre commande.
				</div>
				<a [routerLink]="route.get('cart-payment')" class="btn green">Retour au paiement</a>
			</div>
		</div>
	</div>
</div>
